module.exports = __webpack_public_path__ + "img/tide_indicator.b51e62eb.svg";